/**
 * The date shown on a history row (design brief: Conversation history): "Today, 9:42 AM" for today's
 * conversations, "Oct 14" for earlier ones this year, "Oct 14, 2025" for an earlier year.
 */

import { asIsoDateTimeString, formatTimestamp, todayInTimezone } from '@resida/shared';

const LOCAL_TZ = Intl.DateTimeFormat().resolvedOptions().timeZone;

export function conversationDate(updatedAt: string, timezone: string = LOCAL_TZ): string {
  const iso = asIsoDateTimeString(updatedAt);
  const today = todayInTimezone(timezone);
  const day = new Intl.DateTimeFormat('en-CA', { timeZone: timezone }).format(new Date(updatedAt));
  if (day === today) {
    return `Today, ${formatTimestamp(iso, timezone, { hour: 'numeric', minute: '2-digit' })}`;
  }
  const sameYear = day.slice(0, 4) === today.slice(0, 4);
  return formatTimestamp(iso, timezone, sameYear ? { month: 'short', day: 'numeric' } : { month: 'short', day: 'numeric', year: 'numeric' });
}
